import { PushNotifications } from '@capacitor/push-notifications';

export const useCapacitorPushNotifications = () => {
  const addListeners = async () => {
    await PushNotifications.addListener('registration', token => {
      console.info('Registration token: ', token.value);
    });

    await PushNotifications.addListener('registrationError', err => {
      console.error('Registration error: ', err.error);
    });

    await PushNotifications.addListener('pushNotificationReceived', notification => {
      console.log('Push notification received: ', notification);
    });

    await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
      console.log(
        'Push notification action performed',
        notification.actionId,
        notification.inputValue
      );
    });
  };

  const initPushNotifications = async () => {
    let permStatus = await PushNotifications.checkPermissions();

    try {
      permStatus = await PushNotifications.requestPermissions();
      console.log('requestPermissions result:', permStatus.receive);
    } catch (err) {
      console.error('requestPermissions THREW:', err);
      return false;
    }

    if (permStatus.receive !== 'granted') {
      return false;
    }

    await addListeners();
    await PushNotifications.register();
    return true;
  };

  return { initPushNotifications };
};
